import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { ADDRESS_STATUS } from "../../utils/AppEnumerations";

interface IStatusPayload {
  status: ADDRESS_STATUS;
  reason?: string;
}

export const GET_ALL_ADDRESS = (
  pagination: IPagination,
  search: string,
  advanceSearch: string
) => {
  const searchStatus =
    advanceSearch.length > 0 ? `&status=${advanceSearch}` : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_Address.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchStatus}`,
    API_ENDPOINTS.get_all_Address.method
  );
};

export const UPDATE_ADDRESS_STATUS = (id: string, payload: IStatusPayload) => {
  return serviceMaker(
    API_ENDPOINTS.update_address_status.url + `/${id}`,
    API_ENDPOINTS.update_address_status.method,
    payload
  );
};
